export const SociallyDistanced = {
  name: '',
  sociallyDistanced: true
}
